module.exports = __webpack_public_path__ + "static/media/IconRuasPavimentadas.628c72bb.svg";